import { Page } from 'layouts/Page';
import { FC } from 'react';
import { MonthlyFee } from 'components/MonthlyFee';

export const MonthlyFeePage: FC = () => {
	return (
		<Page title="Monthly Fee – EAS Control Center">
			<MonthlyFee />
		</Page>
	);
};
